import type { Component } from 'solid-js'
// import { useSearchParams } from '@solidjs/router'
import { Logger } from 'besonders-logger'
// import { updateAgentState } from '../data/AgentStore'
// import { createHandleAuthFx } from '../ipfs/web3storage'
// import { SetupDialog } from './SetupDialog'
import classNames from 'classnames'
import { For, Show } from 'solid-js'
import { syncState, triggerSync } from '../ipfs/sync-service'
import { isOnline, isStorageReachable, showOnlineState } from '../ui/online-second'
import { Iconify, Online } from './mini-components'
import { TransferProgress } from './TransferProgress'
import { useAgent } from '../data/agent/AgentState'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO, { prefix: '[w3]' }) // eslint-disable-line unused-imports/no-unused-vars

function formatError(error: any): string {
	if (!error) return 'Unknown error'
	if (error instanceof Error) return error.message
	if (error instanceof Event) {
		const target = error.target as any
		const url = target?.url || target?.responseURL
		const status = target?.status
		const parts = [`${error.type} event`]
		if (status) parts.push(`status ${status}`)
		if (url) parts.push(url)
		return parts.join(' — ')
	}
	if (typeof error === 'string') return error
	if (typeof error === 'object') {
		if (error.message) return error.message
		try {
			return JSON.stringify(error)
		} catch {
			return String(error)
		}
	}
	return String(error)
}

export const SyncButton: Component<{}> = (props) => {
	const agent = useAgent()
	// const [isFetching] = createDeferredResource(async () => {
	// 	DEBUG(`SyncButton.syncing`, props)
	// 	// if (!props.pubID) return null
	// 	// if (matchingSubOrPub()) return null
	// 	// return await retrievePubDataWithExtras(baseDS, props.pubID, props.pinCID)
	// 	await sleep(777)
	// 	return 1
	// })
	const currentSync = () =>
		Array.isArray(syncState.syncing) && syncState.syncing.length ? syncState.syncing[syncState.syncing.length - 1] : null

	return (
		<>
			<Show when={showOnlineState() && (!isOnline() || !isStorageReachable())}>
				<Online size={6} bold />
			</Show>
			<Show when={isOnline()}>
				<style>
					{`
						.sync-tooltip::part(body) {
							pointer-events: auto;
							user-select: text;
							-webkit-user-select: text;
						}
					`}
				</style>
				<wa-tooltip
					trigger='click hover'
					placement='bottom-end'
					class='sync-tooltip'
					style={{ '--max-width': 'min(56rem, 90vw)' }}
					>
						<div slot='content' onclick={(e) => e.stopPropagation()}>
							<div>
								<div>Interval: {syncState.syncInterval}s</div>
								<Show when={syncState.pendingCount > 0}>
									<div mt-1 text-amber>
										⏳ {syncState.pendingCount} share(s) with unpushed changes — will push when reception allows
									</div>
								</Show>
								<Show when={syncState.activeWatchers > 0}>
									<div mt-2>
										<h3>Realtime: {syncState.activeWatchers} subscription(s)</h3>
										<For each={Array.from(syncState.watchers.keys())}>
											{(subId) => {
												const sub = agent.subscriptionsMap.get(subId)
												const status = syncState.watcherConnections.get(subId)
												return (
													<div flex='~ items-center' gap-1>
														<span text-xs>{status === 'connected' ? '🟢' : '🔴'}</span>
														<span>{sub?.name || subId}</span>
														<span text-xs opacity-60>({status})</span>
													</div>
												)
											}}
										</For>
									</div>
								</Show>
								<Show when={syncState.syncing && syncState.syncing.length > 0}>
									<div mt-2>
										<h3>Syncing:</h3>
										<For each={syncState.syncing}>
											{(entry) => {
												if ('sub' in entry && entry.sub) {
													const sub = agent.subscriptionsMap.get(entry.sub)
													return (
														<div flex='~ col' gap-1 mb-1>
															<div>
																<strong>↓ Pulling:</strong> {sub?.name || entry.sub}
															</div>
															<TransferProgress id={entry.sub} compact />
														</div>
													)
												} else if ('share' in entry && entry.share) {
													const share = agent.sharesMap.get(entry.share)
													return (
														<div flex='~ col' gap-1 mb-1>
															<div>
																<strong>↑ Pushing:</strong> {share?.name || entry.share}
															</div>
															<TransferProgress id={entry.share} compact />
														</div>
													)
												}
												return null
											}}
										</For>
									</div>
								</Show>
								<Show when={syncState.errors.length}>
									<div mt-2 text-red break-words w-full overflow-auto flex='~ col' gap-2>
										<h3>Errors:</h3>
										<For each={syncState.errors}>
											{({ sub, share, error }) => (
												<div break-words>
													<strong>{sub?.name || share?.name || 'general'}</strong>
													:
													<div m-0 p-0 break-words>{formatError(error)}</div>
												</div>
											)}
										</For>
									</div>
								</Show>
							</div>
						</div>
					<div class='relative inline-flex'>
						<Iconify
							onclick={() => !syncState.syncing && !syncState.errors.length && triggerSync()}
							// TODO tap and hold too:
							onAuxClick={() => {
								// if (syncState.syncInterval > 0) syncState.syncInterval = 0
								// else syncState.syncInterval = 300
								triggerSync()
							}}
							size={6}
							class={classNames(
								syncState.errors.length
									? 'text-red'
									: (syncState.syncing
										? [
											(currentSync() as { sub?: string; share?: string } | null)?.share ? 'text-green' : 'text-blue',
											'animate-[spin_2s_linear_infinite]',
										]
										: (syncState.syncInterval > 0 ? '' : 'opacity-60')),
							)}
							name='arrows-down-up-fill'
						/>
						<Show when={syncState.pendingCount > 0 && !syncState.syncing}>
							<span class='absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-amber-500 text-white text-2.5 font-bold flex items-center justify-center pointer-events-none'>
								{syncState.pendingCount}
							</span>
						</Show>
					</div>
				</wa-tooltip>
			</Show>
		</>
	)
}
